import React from "react";
import { cn } from "@/lib/utils";

export function Wordmark({ collapsed = false, className }) {
  return (
    <div className={cn("flex items-center gap-2.5 select-none", className)} data-testid="app-wordmark">
      <span
        aria-hidden
        className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-[color:var(--accent-blue)]"
      >
        <span className="text-[15px] font-bold tracking-[-0.04em] text-[color:var(--accent-blue-ink)]">S</span>
      </span>
      {!collapsed && (
        <span className="text-[15px] font-semibold tracking-[-0.02em] text-[color:var(--chrome-text)]">Social Content Engine</span>
      )}
    </div>
  );
}
